(() => {
  const searchSelector = '[data-open-search-popup]';

  function matchingElements(root, selector) {
    const elements = [];
    if (root instanceof Element && root.matches(selector)) elements.push(root);
    if (root.querySelectorAll) elements.push(...root.querySelectorAll(selector));
    return elements;
  }

  function enhance(root = document) {
    matchingElements(root, searchSelector).forEach((trigger) => {
      if (!trigger.hasAttribute('role')) trigger.setAttribute('role', 'button');
      if (!trigger.hasAttribute('tabindex')) trigger.setAttribute('tabindex', '0');
      if (!trigger.hasAttribute('aria-label')) trigger.setAttribute('aria-label', 'Open search');
    });

    matchingElements(root, 'select[name]:not([aria-label])').forEach((select) => {
      const name = select.getAttribute('name').trim();
      if (name) select.setAttribute('aria-label', name);
    });

    matchingElements(root, '.apo-file__action').forEach((action) => {
      action.style.setProperty('color', '#a80d0d', 'important');
    });

    matchingElements(root, 'img[src*="head_2_480x480.png"]:not([alt])').forEach((image) => {
      image.setAttribute('alt', 'Hair system base measurement guide');
    });

    matchingElements(root, '.product-description h3.h6').forEach((heading) => {
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', '2');
    });
  }

  document.addEventListener('keydown', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest(searchSelector);
    if (!trigger || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    trigger.click();
  });

  const start = () => {
    enhance();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) enhance(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
